import {Box, Stack} from "@mui/material";
import {
    Client,
    ClientAddress,
    ClientAddressFields,
    ClientFields,
    ClientType
} from "../../../../../types/client/clientData";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import Typography from "@mui/material/Typography";
import {AddressFormatter} from "../../../../../utils/formatters/addressFormatter";
import React, {useEffect, useState} from "react";
import {HttpClientAddress} from "../../../../../http/client/httpClient";
import {EntityWithIdFields} from "../../../../../types/baseEntities";


interface ClientSummaryDialogCardProps {
    client: Client,
    action?: () => void
}

const ClientSummaryDialogCard = ({client, action}: ClientSummaryDialogCardProps) => {
    const [address, setAddress] = useState<ClientAddress>()
    
    useEffect(() => {
        HttpClientAddress.getByIdClient(client[EntityWithIdFields.Id]).then((addr) => {
            setAddress(addr.find((a) => a[ClientAddressFields.AddressTypeCode] === 1))
            action && action()
        })
    }, [])
    
    return (
        <Box sx={{ backgroundColor: '#bceff5', borderRadius: '10px', p: 3, width: '100%' }}>
            <Stack direction={'row'} alignItems={'center'} spacing={5}>
                {client[ClientFields.ClientTypeCode] === ClientType.Fisica ? <PersonIcon fontSize={'large'} color={'info'} /> : <BusinessIcon fontSize={'large'} color={'info'}/>}
                <Stack>
                    <Stack direction={'row'} spacing={2} alignItems={'center'}>
                        <Typography variant='subtitle1' fontWeight={500} color={'black !important'}>Razón Social:</Typography>
                        <Typography variant='subtitle1' fontWeight={700} color={'black !important'}>{client[ClientFields.BusinessName]}</Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={2} alignItems={'center'}>
                        <Typography variant='subtitle1' fontWeight={500} color={'black !important'}>Domicilio Fiscal:</Typography>
                        <Typography variant='subtitle1' fontWeight={700} color={'black !important'}>{address ? AddressFormatter.toFullAddress(address) : '-'}</Typography>
                    </Stack>
                </Stack>
            </Stack>
        </Box>
    )
}


export default ClientSummaryDialogCard